// extracted by mini-css-extract-plugin
module.exports = {"text":"Priority_text__-samx","iconContainer":"Priority_iconContainer__3wLOH","icon":"Priority_icon__3zbzD","gifContainer":"Priority_gifContainer__pLMDX"};